module.exports = __webpack_public_path__ + "static/media/2020.4.22垃圾分类两网融合活动.44e4fcca.jpg";